import axios from "axios";

import config from './config';
import no_img from './assets/images/common/no_img.png';
import no_img_middle from './assets/images/common/no_img.png.middle.png';
import no_img_small from './assets/images/common/no_img.png.small.png';

const instance = axios.create({
    baseURL: config.apiUrl,
    timeout: 500000, // 请求超时时间  
    headers: {
        'Content-Type': 'application/json',
    }
})


// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    config.headers['Authorization'] = localStorage.getItem('Authorization');
    //config.headers['Access-Control-Allow-Origin'] = "http://localhost";
    //config.headers['Access-Control-Allow-Method'] = "OPTIONS, TRACE, GET, HEAD, POST, PUT";
    ////config.headers['Content-Type'] = "application/json; charset=utf-8";
    //config.headers['Access-Control-Allow-Headers'] = "Access-Control-Allow-Origin,Content-Type, Authorization, Accept, X-Requested-With";
    //config.headers['Access-Control-Allow-Credentials'] = "true";
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});



// 添加响应拦截器

instance.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response.data;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

/**
 * get请求
 * @param {*} url 请求地址
 * @param {*} param url参数
 */

export const get = async (url, params)=> {
    try {
        const response = await  instance.get(url, {
        params
        });
        return response;
    } catch (error) {
        return error.response; // 抛出错误以便在调用处处理
    }
}

/**
 * post请求
 * @param {*} url 请求地址
 * @param {*} data url参数
 */

export const post = async (url, data) => {
    try {
        const response = await instance.post(url, data);
        return response;
    } catch (error) {
        return error.response; // 抛出错误以便在调用处处理
    }
}

export const getBaseURL = () => {
    return config.apiUrl;
};

export function getUser () {
    const loginItemString = localStorage.getItem('user');
    try {
        const user=  JSON.parse(loginItemString);
        return user;
    } catch (e) {
        return null;
    }
    return null;
};

// 处理图片加载错误的函数  
export const handleImageError = (setErrorState, type, productId) => {
    // 根据type选择默认图片URL  
    let defaultImageUrl;
    if (type === "middle") {
        defaultImageUrl = no_img_middle;
    } else if (type === "small") {
        defaultImageUrl = no_img_small;
    } else {
        defaultImageUrl = no_img;
    }
    if (setErrorState) {
        setErrorState(productId, defaultImageUrl);
    }    
};


export const getCart = () => {
    return get("delianapi/product/cartitem").then(function (response) {
        return response;
    });
}

export const saveCart = (skuid, sum) => {
    return post("delianapi/product/cartsave/update", {
        skuId: skuid,
        sum: sum
    }).then(function (response) {
        return response;
    });
}

